import st from "@/styles/Modals.module.scss";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import WritePinFields from "@/ui/WritePinFields.tsx";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import ResendCounter from "@/ui/ResendCounter.tsx";
import {pin_value, sign_contract_otp_interval, succeded_transaction} from "@/atoms/common.ts";
import useIntervals from "@/hooks/intervals.ts";
import {useAtom} from "jotai/index";
import CommonClass from "@/utils/common.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import useLoans from "@/hooks/loans.ts";
import {useNavigate} from "react-router-dom";
import LoginLoader from "@/ui/LoginLoader.tsx";
import CrLineTransactionInterface from "@/types_and_interfaces/cr_line_transaction_interface.ts";
import {profile} from "@/atoms/profile.ts";

interface Props {
    data:any
    data_handler(x:any):void
}

const SignTransactionContractOTPModal:React.FC<Props> = ({data, data_handler}) => {
    
    const [error, set_error] = useState<boolean>(false)
    const {t} = useTranslation()
    const intervals_hook = useIntervals(sign_contract_otp_interval)
    // const typed_data = data !== undefined ? data as CreditApplicationInterface : {}
    const [pin] = useAtom(pin_value);
    const [reqLoad, setReqLoad] = useState<boolean>(false)
    const loans = useLoans()
    const navigate = useNavigate()
    const [, set_succeded_application] = useAtom(succeded_transaction)
    const [user] = useAtom(profile)
    
    const typed_data = data as CrLineTransactionInterface
    
    const handleSetReqLoad = (x:boolean) => {
        setReqLoad(x);
    };
    
    const step1 = async () => {
        let data = {
            "client_loan_id": typed_data.client_loan_id,
            "urn": typed_data.urn_tr,
        }
        const enabled = await loans.signTransactionContractSt1(data);
        
        if(typeof user !== undefined) {
            
            if (enabled) {
                intervals_hook.setIntervalHandler()
                eventEmitter.emit(CommonClass.CustomEvents.set_resend_interval, false)
                
            } else {
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("error_message"));
            }
        }
    }
    
    const sign = async () => {
        
        setReqLoad(true)
        
        try {
            let data = {
                "client_loan_id": typed_data.client_loan_id,
                "urn": typed_data.urn_tr,
                "otp": pin.join("")
            }
            
            let enable = await  loans.signTransactionContractSt2(data)
            
            if(enable) {
                set_succeded_application(typed_data)
                navigate(DashboardClass.dashboard_routes.SuccessCrLineSign);
            } else {
                set_error(true)
            }
        } catch (e){
            set_error(true)
        }
        
        setReqLoad(false)
    }
    
    useEffect(() => {
        
        if(pin.every(str => str.length > 0)){
            sign()
        }
    }, [pin]);
    
    useEffect(() => {
        
        eventEmitter.on(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
        
        return () => {
            intervals_hook.clear_interval()
            eventEmitter.off(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
        }
        
    }, []);
    
    return (
        <ModalLayout
            className={st.sign_contract_otp_modal}
            // open={true}
            open={Boolean(data)}
            innerClassName={st.sign_contract_otp_modal_inner}
            on_close_state={() => {
                data_handler(undefined)
            }}
        >
            
            <>
                <div className={st.top}>
                    <div className={st.heading}>
                        {t("insert_code")}
                        
                        <div className={st.info}>
                        
                            <span className={st.inf_text}>
                                {t("code_sent_to_nr")}
                            </span>
                            
                            <span className={st.phone_nr}>
                                {user?.phone || ""}
                            </span>
                        
                        
                        </div>
                        
                        <WritePinFields
                            error={error}
                            className={st.pin}
                        />
                    
                    </div>
                    
                    <ResendCounter
                        className={st.resend_otp}
                        onClick={step1}
                        interval_atom={sign_contract_otp_interval}
                    />
                </div>
                
                {reqLoad &&
                    <LoginLoader/>
                }
            </>
        
        </ModalLayout>
    )
}

export default SignTransactionContractOTPModal